import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import { useUserStore } from '@/stores/user'
import { API_BASE_URL } from '@/services/api'


export default /*@__PURE__*/_defineComponent({
  __name: 'BottomNav',
  setup(__props) {

const route = useRoute()
const userStore = useUserStore()
const activeItem = ref('overview')
const pendingCount = ref(0)

const baseItems = [
  { value: 'overview', to: '/overview', icon: 'mdi-chart-box', title: 'Обзор' },
  { value: 'payments', to: '/payments', icon: 'mdi-cash', title: 'Платежи' },
  { value: 'services', to: '/services', icon: 'mdi-sim', title: 'Сервисы' },
]

const menuItems = computed(() => {
  if (pendingCount.value > 0) {
    return [...baseItems, { value: 'requests', to: '/requests', icon: 'mdi-clipboard-text-clock', title: 'Заявки' }]
  }
  return baseItems
})

const fetchPendingCount = async () => {
  const phone = userStore.state?.context?.user?.phoneNumber?.substring(4) || ''
  if (!phone) return
  try {
    const { data } = await axios.get(`${API_BASE_URL}/requests/pending?phone=${phone}`)
    pendingCount.value = data.count || 0
  } catch (e) {
    // silent
  }
}

watch(() => userStore.state.value, (state) => {
  if (state === 'authenticated') {
    fetchPendingCount()
    setInterval(fetchPendingCount, 30000)
  }
}, { immediate: true })

watch(() => route.path, (newPath) => {
  const item = menuItems.value.find(item => item.to === newPath)
  if (item) {
    activeItem.value = item.value
  }
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_bottom_navigation = _resolveComponent("v-bottom-navigation")!

  return (_openBlock(), _createBlock(_component_v_bottom_navigation, {
    modelValue: activeItem.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeItem).value = $event)),
    height: "56",
    class: "bottom-nav"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item) => {
        return (_openBlock(), _createBlock(_component_v_btn, {
          key: item.value,
          value: item.value,
          to: item.to
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.icon), 1)
              ]),
              _: 2
            }, 1024),
            _createElementVNode("span", null, _toDisplayString(item.title), 1)
          ]),
          _: 2
        }, 1032, ["value", "to"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})